export const homeData = {
    splash: {


        
        src: "./images/splash/s_1.jpg",
        title: "Honfleur",
        photographer: "Christopher Goldsack"
    },
    nextMeeting: {
        date: "Tuesday 10th June 2025",
        about: "Themed Competition - 'Food' - Judge: Paul Graber",
    },
        highlight:{
        title: "Annual Exhibition",
        about: "1st - 6th September 2025, Molesey Methodist Church; Judge - Amanda Wright"
    }
};



// WEBPACK FOOTER //
// ./src/data/home.js